import { mutateApi, queryApi } from "src/utils/api/ApiMethods"
import { camelCaseToSnakecase } from "src/utils/string_helpers"

export const queryActiveIntegration = ({ marinaSlug }) => {
  return queryApi(`/manage/${marinaSlug}/integrations/apideck/consumers`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
}

export const createApideckSession = ({ marinaSlug }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/integrations/apideck/sessions`,
    method: "POST",
  })
}

export const updateApideckConsumer = ({ marinaSlug, data }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/integrations/apideck/consumers`,
    method: "PUT",
    data,
  })
}

export const resetApideckConsumer = ({ marinaSlug }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/integrations/apideck/consumers`,
    method: "DELETE",
  })
}

export const queryInvoiceItems = (marinaSlug) => {
  return queryApi(`/manage/${marinaSlug}/integrations/apideck/invoice_items`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
}

export const updateInvoiceItem = ({ marinaSlug, id, data }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/integrations/apideck/invoice_items/${id}`,
    method: "PATCH",
    data,
  })
}

export const queryApideckInvoices = ({ marinaSlug, filters, pageSize }) => {
  const { page, searchTerm, sortDirection, sortKey } = filters
  const paramsObj = {}

  if (searchTerm) {
    paramsObj.search = searchTerm
  }

  if (sortKey) {
    paramsObj.sort = sortKey ? camelCaseToSnakecase(sortKey) : null
    paramsObj.direction = sortDirection
  }

  paramsObj.page = page
  paramsObj.per_page = pageSize

  const urlParams = new URLSearchParams(paramsObj)
  const url = `/manage/${marinaSlug}/integrations/apideck/invoices?${urlParams.toString()}`

  return queryApi(url, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
}

export const retryInvoiceSync = ({ marinaSlug, id }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/integrations/apideck/invoices/${id}/retries`,
    method: "POST",
  })
}
